export const ADMIN_QUICK_LOGIN_EVENT = 'liberty-open-admin-quick-login';

export function openAdminQuickLogin() {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(ADMIN_QUICK_LOGIN_EVENT));
  }
}

export function isMobileWebShortcutEnabled() {
  if (typeof window === 'undefined') return false;
  const touch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  const narrow = window.matchMedia('(max-width: 768px)').matches;
  const coarse = window.matchMedia('(pointer: coarse)').matches;
  return touch && (narrow || coarse);
}
